import {NgForOf, NgIf} from "@angular/common";
import {Component, Inject, OnInit} from '@angular/core';
import {FlexModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatOptionModule} from "@angular/material/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatSelectModule} from "@angular/material/select";
import {LeaseDocument, LeaseDocumentType} from "../../../leasing.model";
import {LeaseDocumentsService} from "../lease-documents.service";

@Component({
  selector: 'app-add-document-dialog',
  templateUrl: './add-document-dialog.component.html',
  imports: [
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    FlexModule,
    MatButtonModule,
    NgForOf,
    NgIf
  ],
  standalone: true
})
export class AddDocumentDialogComponent implements OnInit {

  docTypes: LeaseDocumentType[] = [];
  fileToUpload: File | null = null;
  fileName: string | null = null;

  document: LeaseDocument | null = null;
  documentTypeCode: string | null = null;

  errorMessage: string | null = null;

  leaseId!: string;

  constructor(public dialogRef: MatDialogRef<AddDocumentDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: {
                leaseId: string,
                excludeTypes?: string[],
                setType?: string,
                fileNamePrefix?: string
              },
              private documentsService: LeaseDocumentsService) {
    this.leaseId = data.leaseId;
  }

  ngOnInit() {
    this.loadLeaseDocumentTypes();
  }

  loadLeaseDocumentTypes() {
    this.documentsService.getDocumentTypes().subscribe({
      next: value => {
        if (this.data.excludeTypes) {
          this.docTypes = value.filter(f => !this.data.excludeTypes!.includes(f.code));
        } else if (this.data.setType) {
          this.docTypes = value.filter(f => this.data.setType === f.code);
          if (this.docTypes.length === 1) {
            this.documentTypeCode = this.docTypes[0].code;
          }
        } else {
          this.docTypes = value
        }
      },
      error: err => console.log(err)
    })
  }

  uploadDocument() {
    this.errorMessage = '';
    if (this.fileToUpload !== null) {
      this.documentsService.saveLeaseDocument(this.documentTypeCode!, this.fileToUpload!, this.leaseId).subscribe({
        next: value => this.close(),
        error: err => this.errorMessage = err.message
      })
    }
  }

  fileChangeEvent(event: any): void {
    this.fileToUpload = event.files.item(0);
    this.fileName = this.fileToUpload!.name;
  }

  close() {
    this.dialogRef.close();
  }

}
